/**
 * useRelationRules - the table's rulings every relation reads, as one record (`RelationRules`, 2026-10-26): the cover
 * reach (`coverNearTarget`) and each horde's magnitude, since a horde's reach counts from the mob's edge. Built once
 * in the shell and handed on whole, so a new ruling is one field, not a thread through every hop.
 *
 * THE SAME OBJECT until the reach or a horde's magnitude changes: the roster is replaced on every write, and the
 * relations, the tape and the cue are memoised on this - a wound to anyone else must not re-measure the map.
 */
import { useMemo } from 'react';
import { hordeMagnitudes } from '../engine/roster/hordes';

export default function useRelationRules(coverReach, roster) {
  const key = useMemo(() => JSON.stringify(hordeMagnitudes(roster ?? [])), [roster]);
  return useMemo(() => ({ coverReach, hordeMagnitude: JSON.parse(key) }), [coverReach, key]);
}
